import type { ReactNode } from "react";
import { cn } from "@nexus/ui";

interface KpiChartCardMessageProps {
  children: ReactNode;
  tone?: "muted" | "error";
}

/** Chart-sized card holding a single line of copy (empty, error, or nothing selected). */
export function KpiChartCardMessage({ children, tone = "muted" }: KpiChartCardMessageProps) {
  return (
    <div className="flex min-h-[406px] items-center justify-center rounded-[14px] border bg-card p-[21px]">
      <p className={cn("text-sm", tone === "error" ? "text-destructive" : "text-muted-foreground")}>
        {children}
      </p>
    </div>
  );
}
